import { HistoryToTransfert } from '@app/home/models/history.model';
import { ObjectToTransfert } from '@app/home/models/metric.model';
import { SimulationType } from '@core/models/simulation-metadata.model';
import { createAction, props } from '@ngrx/store';

import { CalculateData } from '../models/calculate-data.model';

export const resetState = createAction('[Launch simulation] Reset state');

export const selectSimulation = createAction(
  '[Launch simulation] Select simulation',
  props<{ simulationType: SimulationType }>()
);
export const selectStep = createAction(
  '[Launch simulation] Select step',
  props<{ step: 'calculate' | 'transfert'; data?: CalculateData }>()
);

export const transfertHistorySuccess = createAction(
  '[Launch simulation] Get transfert history success',
  props<{ history: Array<HistoryToTransfert> }>()
);

export const launchSimulation = createAction('[Launch simulation] Launch simulation', props<{ data: CalculateData }>());
export const launchSimulationSuccess = createAction('[Launch simulation] Launch simulation success');
export const launchSimulationError = createAction('[Launch simulation] Launch simulation failure');

export const launchSimulationWithTransfert = createAction(
  '[Launch simulation] Launch simulation with transfert',
  props<{ data: Array<ObjectToTransfert> }>()
);
export const launchSimulationWithTransfertSuccess = createAction(
  '[Launch simulation] Launch simulation with transfert success'
);
export const launchSimulationWithTransfertError = createAction(
  '[Launch simulation] Launch simulation with transfert failure'
);

export const cancelSimulation = createAction('[Launch simulation] Cancel simulation');
export const cancelSimulationSuccess = createAction('[Launch simulation] Cancel simulation success');
export const cancelSimulationError = createAction('[Launch simulation] Cancel simulation failure');
